import { mapGetters } from "vuex";

export default {
  name: "projects-table",
  props: {
    title: String,
  },
  data() {
    return {
      type: "dark",
      loading: false,
      tableData: [],
    };
  },
  computed: {
    ...mapGetters({
      mainLoading: "isLoading",
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/documents", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
        })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
